module.exports = __webpack_public_path__ + "media/Video 74.667d215d.mp4";